import { FC } from "react";
import { Navigate } from "react-router-dom";

import { PageContextWrapper } from "@ryde/controls";
import { useIsMobile, usePrefixedRouting } from "@ryde/shared";

import { DASHBOARD_ENTITY } from "./dynamic-dashboard.models";
import { DynamicDashboardPageContent } from "./dynamic-dashboard.page.content";

/**
 * Dynamic Dashboard — the home page (RYDE-6930). Reuses the shared page shell.
 * Custom cards pull live data from the reports engine; saved Views persist via
 * the real ViewApi (the `dashboard` entity is registered). `skipSchemaFetch`
 * skips the per-entity form/grid schema, which the dashboard doesn't use.
 */
export const DynamicDashboardPage: FC = () => {
  const { isMobile } = useIsMobile();
  const { addPrefix } = usePrefixedRouting();

  if (isMobile) {
    return <Navigate to={addPrefix("/rides")} replace />;
  }

  return (
    <PageContextWrapper entity={DASHBOARD_ENTITY} skipSchemaFetch>
      <DynamicDashboardPageContent />
    </PageContextWrapper>
  );
};
